import React from 'react';
export { ProjectList } from './List';
export { ProjectDetails } from './Details';
export { ProjectSettings } from './Details/Settings';
export { Events as ProjectEvents } from './Details/Events';
export { ProjectAdd } from './Add';
export { CreateProjectWizard } from './CreateWizard';

export const Project: React.FC = () => {
    return null;
};
